import { Component, Input } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { validatorErrorMessage } from '../../../../shared/validators';

@Component({
    selector: 'app-loan-input',
    templateUrl: './loan-input.component.html',
    styleUrl: './loan-input.component.scss',
    standalone: false
})
export class LoanInputComponent {
    validatorErrorMessage = validatorErrorMessage;
    @Input({ required: true }) label: string = '';
    @Input() type: string = 'text';
    @Input() control!: FormControl;
    @Input() placeholder: string = '';
    @Input() required: boolean = false;
    @Input() enableVisibilityToggle: boolean = false;
    @Input() readonly: boolean = false;
    /** When provided, shows a question mark tooltip next to the label. */
    @Input() tooltipText?: string;

    private isPasswordVisible = false;

    get isRequired(): boolean {
        return this.required || this.control.hasValidator(Validators.required);
    }

    get resolvedType(): string {
        if (!this.enableVisibilityToggle) return this.type;
        if (this.type !== 'password') return this.type;
        return this.isPasswordVisible ? 'text' : 'password';
    }

    get toggleAriaLabel(): string {
        return this.isPasswordVisible ? 'Hide password' : 'Show password';
    }

    toggleVisibility = (e: Event) => {
        e.preventDefault();
        e.stopPropagation();
        this.isPasswordVisible = !this.isPasswordVisible;
    };
}
